<template>
  <div>
    <page-header
      :page="page"
      :has-return="false"
      :left-side-class="'col-xl-8'"
      :right-side-class="
        'col-xl-4 align-items-end d-flex pb-2 justify-content-end'
      "
    >
      <template v-slot:customActions>
        <ActionButton
          i="fas fa-arrow-circle-left"
          variant="ab-btn  ab-btn-outline-success m-1"
          @click="onReturn"
        >
          Regresar
        </ActionButton>
      </template>
    </page-header>
    <div class="row">
      <div class="col-11 mx-auto">
        <Board v-if="studentDetails" :details="studentDetails" />
      </div>
    </div>

    <time-line
      v-if="statusHistory && statusHistory.length"
      class="mt-4 col-11 mx-auto px-0"
    >
      <time-line-item
        v-for="(row, index) in statusHistory"
        :key="index"
        class="custom-time-line rounded"
      >
        <div class="row">
          <div class="col-12 col-md-3 flex-column d-flex">
            <label class="mb-0 px-2 pt-1">{{ row.tabName }}</label>
          </div>
          <div class="col-12 col-md-3 mt-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Usuario:</label>
            <span>{{ row.userName }}</span>
          </div>
          <div class="col-12 col-md-3 mt-2 flex-column d-flex">
            <label class="mb-0 color-gray-6 text-small">Nombre:</label>
            <span>{{ row.name }}</span>
          </div>
          <div class="col-12 col-md-3 flex-column d-flex mt-2">
            <label class="mb-0 color-gray-6 text-small">Estatus:</label>
            <span class="d-flex align-items-baseline">
              <div
                class="status-indicator"
                :style="{ backgroundColor: row.status.color }"
              >
                &nbsp;
              </div>
              <span>{{ row.status.text }}</span>
            </span>
          </div>
        </div>
        <template #icon>
          <em :class="`far fa-user-circle color-green fa-2x`" class="radius" />
        </template>
        <template #date>
          <div class="date-container">
            <div class="color-black font-14 font-weight-bold fulldate">
              {{ formatDate(row.date) }}
              <small>{{ getTimeFromDate(row.date) }}</small>
            </div>
          </div>
        </template>
        <div id="comment-info" class="mt-3">
          <div class="info-panel bg-white rounded">
            <div class="row">
              <div class="col">
                <div class="info-panel-main-title">
                  <span class="color-gray-6 text-small">Observación:</span>
                </div>
              </div>
            </div>
            <div class="info-panel-container">
              <div class="info-panel-item row">
                <div class="col-12 ">
                  <label>{{ row.comment }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-right">
          <ActionButton
            v-if="canRemoveObservation"
            variant="danger mt-3"
            i="fa fa-times-circle"
            @click="onObservationRemove(row.id)"
          >
            Eliminar
          </ActionButton>
        </div>
      </time-line-item>
    </time-line>
    <CustomResultNotFound v-else />

    <div
      v-if="
        pagination.totalItemCount > 5 &&
          pagination.totalItemCount != statusHistory.length
      "
      class="row"
    >
      <div class="col text-center">
        <action-button
          variant="outline-success custom-view-more"
          i="fas fa-chevron-down"
          @click="loadMore"
        >
          Ver más
        </action-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getHistory } from './_api';
import studentApi from '@/services/student.js';
import { TimeLine, TimeLineItem } from '@quisit/mipe-timeline';
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import moment from 'moment';
import Board from 'Board';
import CustomResultNotFound from 'custom-result-not-found';
import store from '@/store/index';
import alert from '@/mixin/alert.mixin';
import { removeObservation } from '@/components/pei/ubication-tech-assistance/_api';

export default {
  name: 'UtaObservations',
  mixins: [alert],
  components: {
    Board,
    TimeLine,
    TimeLineItem,
    ActionButton,
    PageHeader,
    CustomResultNotFound,
  },
  data() {
    return {
      page: {
        icon: 'fas fa-user-edit',
        title: 'Observaciones',
        routes: [
          'Inicio',
          'Manejo de Solicitud de Asistencia Técnica de Ubicación del Estudiante',
        ],
      },
      payload: {
        RequestId: null,
        PageIndex: 1,
        PageSize: 10,
      },
      pagination: {
        totalItemCount: null,
        perPage: 10,
      },
      statusHistory: [],
      student: null,
      selectedMeetings: [],
      meetingsSelected: false,
    };
  },
  computed: {
    businessId(){
      const statusHistory = this.statusHistory;
      const businessId = this.statusHistory.length > 0 ? this.statusHistory[0].businessId : '';
      return businessId;
    },
    studentDetails() {
      if (!this.student) return;
      return [
        [
          {
            label: 'Estudiante',
            data: `${this.student.studentId} - ${this.student.fullName}` ,
            icon: 'fas fa-address-book',
          },
          {
            label: 'Número de Consulta',
            data: this.businessId,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Escuela',
            data: `${this.student.schoolCode} - ${this.student.schoolName}`,
            icon: 'fas fa-clipboard-list-check',
          },
          {
            label: 'Impedimento',
            data: this.student.impediment,
            icon: 'fas fa-clipboard-list-check',
          },
        ],
      ];
    },
    canRemoveObservation() {
      return store.getters.HasPermission('ubication.tech.assistance.remove.observation');
    },
  },
  methods: {
    async onObservationRemove(id) {
      try {  
        await removeObservation(id);
        this.ShowToast('', "Observación eliminada exitosamente", 'success');
      } catch {
        this.ShowToast('', "Ocurrió un error al intentar eliminar la observación", 'error');
      }

      await this.getHistory();
    },
    onReturn() {
      const fromSearch = this.$route?.query?.from === 'search';
      if (fromSearch) {
        this.$router.push({ name: 'uta-search' });
        return;
      }
      this.$router.push({
        name: 'uta-management',
        params: { tapRequestId: this.$route.params.tapRequestId },
      });
    },
    async getHistory() {
      const response = await getHistory(this.payload);
      this.statusHistory = response.data;
      this.pagination.totalItemCount = response.totalItemCount;
    },
    formatDate(value) {
      return `${moment(value).format('DD/MMM/YYYY')}`.toLowerCase();
    },
    getTimeFromDate(date) {
      return moment(date).format('hh:mm a');
    },
    async loadMore() {
      this.payload.PageSize += this.pagination.perPage;
      await this.getHistory(this.payload);
    },
    async getStudent(sie) {
      const { data } = await studentApi.getBySie(sie);
      this.student = data;
    },
  },
  async created() {
    this.payload.RequestId = this.$route.params.tapRequestId;
    await Promise.all([
      this.getStudent(this.$route.params.studentSIE),
      this.getHistory(this.payload),
    ]);
  },
};
</script>

<style lang="scss" scoped>
.radius {
  width: 25px !important;
  height: 25px !important;
  padding: 0 !important;
  background-color: transparent !important;
}
.status-indicator {
  width: 12px;
  height: 12px;
  float: left;
  border-radius: 50%;
  margin-right: 5px;
}
.text-small {
  font-size: 0.875rem;
}
.info-panel {
  padding: 15px 10px 1px 20px;
  border-bottom: none;
  border-radius: 0px 0px 5px 5px;
  opacity: 1;
}
.info-panel-container {
  overflow-wrap: anywhere;
  display: flex;
  flex-flow: row wrap;
  padding: 0px 10px 1px 23px;
  .info-panel-item {
    flex: 1 0 25%;
    margin-bottom: 1.5em;
    float: left;
    box-sizing: border-box;
    padding-right: 10px;
    span {
      display: block;
      text-align: left;

      letter-spacing: 0px;
    }
    label {
      margin-top: 10px;
      text-align: left;
      font-size: 1rem;
      letter-spacing: 0px;

      line-height: 1.6em;
    }
  }
}
</style>
